/**
 * Grandeur Automatic phased early-access gate (soft client gate).
 * - argon_grandeur_code=1 → regular access code validated
 * - argon_grandeur_immediate=1 → immediate purchase unlock (any time)
 * - Purchase unlock (html[data-grandeur-unlocked]) when:
 *   public launch open, OR early access open + valid code,
 *   OR immediate-unlock cookie, OR force-open mode
 */
(function () {
  if (window.ArgonGrandeurAccess) return;

  var CODE_COOKIE = 'argon_grandeur_code';
  var IMMEDIATE_COOKIE = 'argon_grandeur_immediate';
  var LEGACY_COOKIE = 'argon_grandeur_access';
  var ATTR = 'data-grandeur-unlocked';
  var DEFAULT_EARLY = '2026-09-23T18:00:00+02:00';
  var DEFAULT_PUBLIC = '2026-09-24T18:00:00+02:00';

  if (!document.getElementById('grandeur-access-boot-css')) {
    var style = document.createElement('style');
    style.id = 'grandeur-access-boot-css';
    style.textContent =
      'html:not([data-grandeur-unlocked="true"]) [data-grandeur-unlocked]{display:none!important;}' +
      'html[data-grandeur-unlocked="true"] [data-grandeur-locked]{display:none!important;}' +
      'html:not([data-grandeur-early-access="true"]) [data-grandeur-early-access-bar]{display:none!important;}' +
      'html:not([data-grandeur-early-code-only="true"]) [data-grandeur-early-code-only]{display:none!important;}' +
      'html[data-grandeur-early-code-only="true"] [data-grandeur-early-code-only]{display:block!important;}' +
      'html[data-grandeur-early-code-only="true"] [data-grandeur-hide-on-early-code]{display:none!important;}';
    document.head.appendChild(style);
  }

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function writeCookie(name, value, days) {
    var maxAge = Math.max(1, parseInt(days, 10) || 14) * 86400;
    var secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = name + '=' + encodeURIComponent(value) + '; Path=/; Max-Age=' + maxAge + '; SameSite=Lax' + secure;
  }

  function normalizeCode(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '');
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function parseTime(value) {
    var ms = Date.parse(value || '');
    return isNaN(ms) ? 0 : ms;
  }

  function getConfig() {
    var cfg = document.getElementById('grandeur-access-config');
    var launch = document.querySelector('[data-grandeur-launch]');
    var early =
      (launch && launch.getAttribute('data-early-at')) ||
      (cfg && cfg.getAttribute('data-early-at')) ||
      DEFAULT_EARLY;
    var pub =
      (launch && launch.getAttribute('data-public-at')) ||
      (cfg && cfg.getAttribute('data-public-at')) ||
      DEFAULT_PUBLIC;
    return {
      earlyAt: parseTime(early),
      publicAt: parseTime(pub)
    };
  }

  function hasValidCode() {
    return readCookie(CODE_COOKIE) === '1' || readCookie(LEGACY_COOKIE) === '1';
  }

  function hasImmediateUnlock() {
    return readCookie(IMMEDIATE_COOKIE) === '1';
  }

  function hasCodeAccess() {
    return hasValidCode() || hasImmediateUnlock();
  }

  function isPublicOpen() {
    var cfg = getConfig();
    return !!(cfg.publicAt && Date.now() >= cfg.publicAt);
  }

  function isEarlyOpen() {
    var cfg = getConfig();
    return !!(cfg.earlyAt && Date.now() >= cfg.earlyAt);
  }

  function applyUnlocked(unlocked) {
    if (unlocked) {
      document.documentElement.setAttribute(ATTR, 'true');
    } else {
      document.documentElement.removeAttribute(ATTR);
    }
  }

  function applyEarlyAccessBanner() {
    // Gold top bar for code-holders, shown as soon as code is valid (even before launch)
    if (isPublicOpen()) {
      document.documentElement.removeAttribute('data-grandeur-early-access');
      return;
    }

    var wasEarlyAccess = document.documentElement.getAttribute('data-grandeur-early-access') === 'true';
    var show = hasImmediateUnlock() || hasValidCode();

    if (show) {
      document.documentElement.setAttribute('data-grandeur-early-access', 'true');
      if (!wasEarlyAccess) {
        document.dispatchEvent(new CustomEvent('grandeur:early-access'));
      }
    } else {
      document.documentElement.removeAttribute('data-grandeur-early-access');
    }

    if (!isPublicOpen() && !isEarlyOpen() && hasValidCode() && !hasImmediateUnlock()) {
      document.documentElement.setAttribute('data-grandeur-early-code-only', 'true');
    } else {
      document.documentElement.removeAttribute('data-grandeur-early-code-only');
    }
  }

  function toCalendarDate(ms) {
    var d = new Date(ms);
    var YYYY = d.getUTCFullYear();
    var MM = String(d.getUTCMonth() + 1).padStart(2, '0');
    var DD = String(d.getUTCDate()).padStart(2, '0');
    var hh = String(d.getUTCHours()).padStart(2, '0');
    var mm = String(d.getUTCMinutes()).padStart(2, '0');
    var ss = String(d.getUTCSeconds()).padStart(2, '0');
    return '' + YYYY + MM + DD + 'T' + hh + mm + ss + 'Z';
  }

  function buildGoogleCalendarUrl(title, description, location, startMs, endMs) {
    var googleUrl = new URL('https://calendar.google.com/calendar/render');
    googleUrl.searchParams.set('action', 'TEMPLATE');
    googleUrl.searchParams.set('text', title);
    googleUrl.searchParams.set('details', description);
    googleUrl.searchParams.set('location', location);
    googleUrl.searchParams.set('dates', toCalendarDate(startMs) + '/' + toCalendarDate(endMs));
    return googleUrl.toString();
  }

  function isIosDevice() {
    var ua = navigator.userAgent || '';
    return /iPhone|iPad|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  }

  function maybeAutoRedirectToCalendar() {
    if (window.__argonCalendarRedirectStarted) return false;

    var params = new URLSearchParams(window.location.search || '');
    if (params.get('add-to-calendar') !== '1' && params.get('calendar') !== '1') return false;

    var btn = document.querySelector('[data-grandeur-calendar-btn]');
    if (!btn) return false;

    window.__argonCalendarRedirectStarted = true;

    var startRaw = btn.getAttribute('data-calendar-start') || '';
    var startMs = Date.parse(startRaw);
    if (isNaN(startMs)) return false;

    var endMs = startMs + 60 * 60 * 1000;
    var title = btn.getAttribute('data-calendar-title') || 'Early Access Launch - Grandeur Automatic';
    var description = btn.getAttribute('data-calendar-description') || 'Early access to Grandeur Automatic opens now. Visit the website to secure your model before the public launch.';
    var location = btn.getAttribute('data-calendar-location') || window.location.origin;
    var googleUrl = buildGoogleCalendarUrl(title, description, location, startMs, endMs);
    var icsUrl = btn.getAttribute('data-calendar-ics') || btn.getAttribute('href') || '';

    if (isIosDevice() && icsUrl) {
      try {
        icsUrl = new URL(String(icsUrl), window.location.href).href;
      } catch (e) {}
      window.location.replace(icsUrl);
      return true;
    }

    window.location.replace(googleUrl);
    return true;
  }

  function bindCalendarButtons() {
    document.querySelectorAll('[data-grandeur-calendar-btn]').forEach(function (btn) {
      if (btn.dataset.calendarBound === 'true') return;
      btn.dataset.calendarBound = 'true';

      var startRaw = btn.getAttribute('data-calendar-start') || '';
      var startMs = Date.parse(startRaw);
      if (isNaN(startMs)) return;

      var endMs = startMs + 60 * 60 * 1000;
      var title = btn.getAttribute('data-calendar-title') || 'Early Access Launch - Grandeur Automatic';
      var description = btn.getAttribute('data-calendar-description') || 'Early access to Grandeur Automatic opens now. Visit the website to secure your model before the public launch.';
      var location = btn.getAttribute('data-calendar-location') || window.location.origin;
      var googleUrl = buildGoogleCalendarUrl(title, description, location, startMs, endMs);
      var icsUrl = btn.getAttribute('data-calendar-ics') || btn.getAttribute('href') || '';

      btn.setAttribute('rel', 'noopener noreferrer');
      btn.removeAttribute('download');

      if (isIosDevice() && icsUrl && icsUrl !== '#') {
        // Plain https .ics link → Safari "Legg til arrangement"-sheet (not webcal subscription)
        try {
          icsUrl = new URL(String(icsUrl), window.location.href).href;
        } catch (e) {}
        btn.setAttribute('href', icsUrl);
        btn.removeAttribute('target');
        return;
      }

      btn.setAttribute('href', googleUrl);
      btn.setAttribute('target', '_blank');
    });
  }

  function canPurchase(forceOpen) {
    if (forceOpen) return true;
    if (hasImmediateUnlock()) return true;
    var now = Date.now();
    var cfg = getConfig();
    if (cfg.publicAt && now >= cfg.publicAt) return true;
    if (cfg.earlyAt && now >= cfg.earlyAt && hasValidCode()) return true;
    return false;
  }

  function isUnlocked() {
    return document.documentElement.getAttribute(ATTR) === 'true' || canPurchase(false);
  }

  function markCodeValid(days) {
    writeCookie(CODE_COOKIE, '1', days);
    // Keep legacy cookie in sync only when purchase is actually allowed
    if (canPurchase(false)) {
      writeCookie(LEGACY_COOKIE, '1', days);
    }
  }

  function markImmediateUnlock(days) {
    writeCookie(IMMEDIATE_COOKIE, '1', days);
    writeCookie(CODE_COOKIE, '1', days);
    writeCookie(LEGACY_COOKIE, '1', days);
  }

  function unlock(days) {
    if (days) markCodeValid(days);
    applyUnlocked(true);
    applyEarlyAccessBanner();
    document.dispatchEvent(new CustomEvent('grandeur:unlocked'));
  }

  function unlockImmediate(days) {
    markImmediateUnlock(days || 14);
    applyUnlocked(true);
    applyEarlyAccessBanner();
    document.dispatchEvent(new CustomEvent('grandeur:unlocked'));
  }

  function applyPublicLaunchState() {
    var launchSections = document.querySelectorAll('[data-grandeur-launch]');
    if (isPublicOpen()) {
      document.documentElement.setAttribute('data-grandeur-public-open', 'true');
      launchSections.forEach(function (el) {
        el.classList.add('is-public-launch-open');
      });
    } else {
      document.documentElement.removeAttribute('data-grandeur-public-open');
      launchSections.forEach(function (el) {
        el.classList.remove('is-public-launch-open');
      });
    }
  }

  function syncPurchaseState(forceOpen) {
    var unlocked = canPurchase(forceOpen);
    applyUnlocked(unlocked);
    applyEarlyAccessBanner();
    applyPublicLaunchState();
    return unlocked;
  }

  function bindTimer(root) {
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    var launchAt = parseTime(root.getAttribute('data-launch-at') || '');
    if (!launchAt) return;

    var daysEl = root.querySelector('[data-timer-days]');
    var hoursEl = root.querySelector('[data-timer-hours]');
    var minutesEl = root.querySelector('[data-timer-minutes]');
    var secondsEl = root.querySelector('[data-timer-seconds]');
    var openLabel = root.getAttribute('data-timer-open-label') || '';

    function tick() {
      var diff = Math.max(0, launchAt - Date.now());
      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);

      if (diff === 0 && openLabel) {
        var labelEl = root.querySelector('[data-timer-label]');
        if (labelEl) labelEl.textContent = openLabel;
      }
    }

    tick();
    setInterval(tick, 1000);
  }

  function setMsg(el, show) {
    if (!el) return;
    el.hidden = !show;
  }

  function bindGate(root) {
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    var expected = normalizeCode(root.getAttribute('data-access-code') || '');
    var immediate = normalizeCode(root.getAttribute('data-immediate-access-code') || '');
    var days = root.getAttribute('data-cookie-days') || '14';
    var silent = root.getAttribute('data-silent-fail') === 'true';
    var form = root.querySelector('[data-grandeur-code-form]');
    var input = root.querySelector('[data-grandeur-code-input]');
    var errorEl = root.querySelector('[data-grandeur-code-error]');
    var pendingEl = root.querySelector('[data-grandeur-code-pending]');
    var successEl = root.querySelector('[data-grandeur-code-success]');
    var gateWrap = root.closest('[data-grandeur-gate]') || root.closest('[data-grandeur-locked]') || root;
    var formWrap = root.querySelector('[data-grandeur-code-form-wrap]') || form;

    if (!expected && !immediate) return;

    function showPending() {
      setMsg(errorEl, false);
      setMsg(successEl, false);
      setMsg(pendingEl, true);

      // Animate: collapse the entire gate (code form + signup)
      var gate = root.closest('[data-grandeur-gate]');
      var signup = document.querySelector('.argon-grandeur-launch__signup');
      var earlyTimer = document.querySelector('.argon-grandeur-launch__timer--early');
      document.documentElement.setAttribute('data-grandeur-pending-transition', 'true');

      setTimeout(function () {
        if (gate) {
          gate.style.maxHeight = gate.scrollHeight + 'px';
          gate.offsetHeight;
          requestAnimationFrame(function () {
            gate.classList.add('is-collapsing');
          });
        }
        if (signup) {
          signup.style.transition = 'opacity 1s ease, max-height 1.25s ease';
          signup.style.maxHeight = signup.scrollHeight + 'px';
          signup.offsetHeight;
          signup.style.opacity = '0';
          signup.style.maxHeight = '0';
          signup.style.overflow = 'hidden';
        }
        if (earlyTimer) {
          earlyTimer.classList.add('is-detached');
        }
      }, 3000);

      // Fade in confirmed banner
      setTimeout(function () {
        var banner = document.querySelector('[data-grandeur-confirmed-banner]');
        if (banner) {
          banner.hidden = false;
          banner.offsetHeight;
          banner.classList.add('is-visible');
        }
        document.documentElement.removeAttribute('data-grandeur-pending-transition');
      }, 4300);
    }

    function showUnlocked() {
      setMsg(errorEl, false);
      setMsg(pendingEl, false);
      setMsg(successEl, true);
      if (gateWrap && gateWrap.hasAttribute('data-grandeur-locked')) {
        gateWrap.hidden = true;
      }
    }

    function scrollToSell() {
      var unlockedPanel = document.querySelector('[data-grandeur-sell]');
      if (unlockedPanel) {
        unlockedPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    // Already past public / early+code / immediate → purchase unlocked
    if (canPurchase(false)) {
      applyUnlocked(true);
      showUnlocked();
      return;
    }

    // Valid code cookie is kept for later unlock, but pending text
    // is only shown after a fresh submit (not after refresh).
    if (!form || !input) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      setMsg(errorEl, false);
      setMsg(pendingEl, false);
      setMsg(successEl, false);

      var entered = normalizeCode(input.value);

      if (immediate && entered === immediate) {
        unlockImmediate(days);
        showUnlocked();
        scrollToSell();
        return;
      }

      if (expected && entered === expected) {
        markCodeValid(days);

        if (canPurchase(false)) {
          unlock(days);
          showUnlocked();
          scrollToSell();
        } else {
          showPending();
        }
        return;
      }

      if (silent) {
        input.value = '';
        input.focus();
        setMsg(errorEl, true);
      } else if (errorEl) {
        setMsg(errorEl, true);
      }
    });
  }

  function init() {
    if (maybeAutoRedirectToCalendar()) return;

    var forceOpen = false;
    document.querySelectorAll('[data-grandeur-force-unlock]').forEach(function (el) {
      forceOpen = true;
      el.removeAttribute('data-grandeur-force-unlock');
    });

    // Migrate legacy unlock cookie → code cookie
    if (readCookie(LEGACY_COOKIE) === '1' && readCookie(CODE_COOKIE) !== '1') {
      writeCookie(CODE_COOKIE, '1', 14);
    }

    syncPurchaseState(forceOpen);

    // Re-check when early/public windows open while page is open
    setInterval(function () {
      var was = document.documentElement.getAttribute(ATTR) === 'true';
      var now = canPurchase(forceOpen);
      applyEarlyAccessBanner();
      if (now && !was) {
        applyUnlocked(true);
        document.dispatchEvent(new CustomEvent('grandeur:unlocked'));
        document.querySelectorAll('[data-grandeur-code-pending]').forEach(function (el) {
          el.hidden = true;
        });
        document.querySelectorAll('[data-grandeur-locked]').forEach(function (el) {
          el.hidden = true;
        });
      }
    }, 1000);

    document.querySelectorAll('[data-grandeur-timer]').forEach(bindTimer);
    document.querySelectorAll('[data-grandeur-code-gate]').forEach(bindGate);
    bindCalendarButtons();
  }

  window.ArgonGrandeurAccess = {
    unlock: unlock,
    unlockImmediate: unlockImmediate,
    isUnlocked: isUnlocked,
    hasValidCode: hasValidCode,
    hasImmediateUnlock: hasImmediateUnlock,
    hasCodeAccess: hasCodeAccess,
    canPurchase: canPurchase,
    init: init
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
